import { combineReducers, EmptyObject } from "redux";
import {
  statisticsBySellerReducer,
  StatisticsBySellerState,
} from "./seller.redux";
import {
  statisticsByRoutePairReducer,
  StatisticsByRoutePairState,
} from "./route-pair.redux";
import { generalStatisticsReducer, GeneralStatisticsState } from "./reducer";
import {
  statisticsByAdvancedReducer,
  StatisticsByAdvancedState,
} from "./advanced.redux";
import {
  statisticsByCustomerReducer,
  StatisticsByCustomerState,
} from "./customer.redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import { PersistPartial } from "redux-persist/es/persistReducer";
import {
  statisticsByAgreedVolumeReducer,
  StatisticsByAgreedVolumeState,
} from "./agreed-volume.redux";

export interface StatisticsState {
  statisticsGeneral: GeneralStatisticsState;
  statisticsBySeller: EmptyObject & StatisticsBySellerState & PersistPartial;
  statisticsByRoutePair: EmptyObject &
    StatisticsByRoutePairState &
    PersistPartial;
  statisticsByAdvanced: EmptyObject &
    StatisticsByAdvancedState &
    PersistPartial;
  statisticsByCustomer: EmptyObject &
    StatisticsByCustomerState &
    PersistPartial;
  statisticsByAgreedVolume: EmptyObject &
    StatisticsByAgreedVolumeState &
    PersistPartial;
}

export const statisticsReducer = combineReducers<StatisticsState>({
  statisticsGeneral: generalStatisticsReducer,
  statisticsBySeller: persistReducer(
    { key: "statisticsBySellerFilter", storage },
    statisticsBySellerReducer
  ),
  statisticsByRoutePair: persistReducer(
    { key: "statisticsByRouterPairFilter", storage },
    statisticsByRoutePairReducer
  ),
  statisticsByAdvanced: persistReducer(
    { key: "statisticsByAdvancedFilter", storage },
    statisticsByAdvancedReducer
  ),
  statisticsByCustomer: persistReducer(
    { key: "statisticsByCustomerFilter", storage },
    statisticsByCustomerReducer
  ),
  statisticsByAgreedVolume: persistReducer(
    { key: "statisticsByAgreedVolume", storage },
    statisticsByAgreedVolumeReducer
  ),
});
